/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const nightWorkerQuestions = [
    {
        id: questionIds.OfficeDuties,
        questionText: "Office Duties",
    },
    {
        id: questionIds.OfficeDutiesFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Driving,
        questionText: "Driving",
    },
    {
        id: questionIds.DrivingFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ManualHandling,
        questionText: "Manual Handling",
    },
    {
        id: questionIds.ManualHandlingFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.OperatingMachinery,
        questionText: "Operating Machinery",
    },
    {
        id: questionIds.OperatingMachineryFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.TypicalPatternNightWork,
        questionText: "Night work is work, which includes the period between 11.00pm and 06:00am. Please describe your typical pattern of night work e.g. number of hours worked per night, number of nights worked per week / month.",
    },
    {
        id: questionIds.HealthSymptomsCausedByNightWork,
        questionText: "Do you currently have any health symptoms which you think are caused by night work, or that are made worse by night work?",
    },
    {
        id: questionIds.HealthSymptomsCausedByNightWorkFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.RegularPillsOrMedication,
        questionText: "Do you take any tablets, pills or medicine regularly? (Include any sleeping tablets and injections).",
    },
    {
        id: questionIds.RegularPillsOrMedicationFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.AttendingHospitalGpReceivingMedicalTreatment,
        questionText: "Are you attending hospital or your GP or receiving any medical treatment at the present time?",
    },
    {
        id: questionIds.AttendingHospitalGpReceivingMedicalTreatmentFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CardiovascularProblems,
        questionText: "Cardiovascular problems",
    },
    {
        id: questionIds.CardiovascularProblemsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ExpectantMother,
        questionText: "Are you a new or expectant mother?",
    },
    {
        id: questionIds.ExpectantMotherFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalCondition,
        questionText: "If you have disclosed a medical condition have you disclosed the same condition on any previous nightworker questionnaires?",
    },
    {
        id: questionIds.NightWorkerHasPreviouslyDisclosedSameMedicalConditionChanges,
        questionText: "Has anything changed with your condition, symptoms or medication since you last disclosed the condition?",
    },
    {
        id: questionIds.NightWorkerPreviouslyDisclosedSameMedicalConditionChanges,
        questionText: "Please provide details",
    },
    {
        id: questionIds.AnxietyStressOrDepression,
        questionText: "Anxiety / Stress or Depression",
    },
    {
        id: questionIds.OtherMentalHealthProblemsIncludingAnyDrugOrAlcoholProblems,
        questionText: "Other Mental Health Problems including any drug or alcohol problems",
    },
    {
        id: questionIds.HeartConditionAnginaHighBloodPressure,
        questionText: "Heart Condition / Angina / High Blood Pressure",
    },
    {
        id: questionIds.AsthmaBronchitisChestDiseaseRespiratoryProblems,
        questionText: "Asthma / Bronchitis / Chest Disease / Respiratory Problems",
    },
    {
        id: questionIds.FitsBlackoutsFaintsUnexplainedLossOfConsciousness,
        questionText: "Fits / Blackouts / Faints / Unexplained loss of consciousness",
    },
    {
        id: questionIds.Diabetes,
        questionText: "Diabetes",
    },
    {
        id: questionIds.StomachOrBowelProblems,
        questionText: "Stomach or Bowel problems",
    },
    {
        id: questionIds.DyslexiaDyspraxiaAutismADHDOrOtherNeurodivergentCondition,
        questionText: "Dyslexia, dyspraxia, autism, ADHD or other neurodivergent condition",
    },
    {
        id: questionIds.OtherHealthProblemsNotCoveredAbove,
        questionText: "Other Health Problems not covered above",
    },
    {
        id: questionIds.DoesYourHealthReduceYourAbilityToWorkSafelyAtNight,
        questionText: "Does your health reduce your ability to work safely at night?",
    },
    {
        id: questionIds.AreYouPregnant,
        questionText: "Are you pregnant?",
    },
    {
        id: questionIds.AdmittedToHospitalDueToAnxietyStressDepressionInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to Anxiety / Stress / Depression in the last two years?",
    },
    {
        id: questionIds.MoreThanTwoConsecutiveWeeksOffSickDueToAnxietyStressDepressionEmotionalBurnoutInTheLastTwoYears,
        questionText: "Have you ever had more than two consecutive weeks off sick due to Anxiety / Stress / Depression / Emotional Burnout in the last two years?",
    },
    {
        id: questionIds.AreYourAnxietySymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.ReceivingOrAwaitingTreatmentForAMentalHealthConcernOrCondition,
        questionText: "Are you currently receiving or awaiting treatment (e.g. therapy, medication…) for a mental health concern or condition?",
    },
    {
        id: questionIds.HaveYouEverHadADrugOrAlcoholProblem,
        questionText: "Have you ever had a drug or alcohol problem?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToAMentalHealthProblem,
        questionText: "Have you been admitted to hospital due to a Mental Health Problem (including Drug and / or Alcohol problems)?",
    },
    {
        id: questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToAMentalHealthProblem,
        questionText: "Have you ever had more than two consecutive weeks off sick due to a Mental Health Problem (including Drug and / or Alcohol problems)?",
    },
    {
        id: questionIds.AreYourDrugOrAlcoholSymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.DoYouHaveAnyCognitiveImpairmentDifficultlyRememberingLearningNewThingsOrBrainFog,
        questionText: "Do you have any cognitive impairment, difficultly remembering, learning new things or brain fog e.g. post COVID or dementia?",
    },
    {
        id: questionIds.HaveYouHadAPsychoticIllness,
        questionText: "Have you had a psychotic illness?",
    },
    {
        id: questionIds.HaveYouBeenDiagnosedWithAPersonalityDisorder,
        questionText: "Have you been diagnosed with a personality disorder?",
    },
    {
        id: questionIds.HaveYouBeenDiagnosedWithAnyOtherMentalHealthCondition,
        questionText: "Have you been diagnosed with any other mental health condition?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToAHeartConditionInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to a Heart condition / Angina / High Blood Pressure in the last two years?",
    },
    {
        id: questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToAHeartConditionInTheLastTwoYears,
        questionText: "Have you ever had more than two consecutive weeks off sick due to a Heart condition / Angina / High Blood Pressure condition in the last two years?",
    },
    {
        id: questionIds.AreYourHeartConditionSymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.DoYouHaveDifficultyWalkingOrClimbingUpStairsDueToAHeartCondition,
        questionText: "Do you have difficulty walking or climbing up stairs due to a Heart condition / Angina / High Blood Pressure condition?",
    },
    {
        id: questionIds.DoesThisHeartConditionAffectYourMobilityInAnyWay,
        questionText: "Does this Heart condition / Angina / High Blood Pressure condition affect your mobility in any way?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToAsthmaProblemsInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to Asthma / Bronchitis / Chest Disease / Respiratory Problems in the last two years?",
    },
    {
        id: questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToAsthmaProblemsInTheLastTwoYears,
        questionText: "Have you ever had more than two consecutive weeks off sick due to Asthma / Bronchitis / Chest Disease / Respiratory Problems in the last two years?",
    },
    {
        id: questionIds.AreYourAsthmaSymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.IfYouSufferFromAsthmaIsThisTriggeredByAnythingThatYouCouldComeInToContactWithAtWork,
        questionText: "If you suffer from asthma is this triggered by anything that you could come in to contact with at work?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToFitsInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to Fits / Blackouts / Fainting or unexplained loss of consciousness in the last two years?",
    },
    {
        id: questionIds.AreYourFitsSymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.AreYourEpisodesOfFitsTriggeredByAnythingThatYouCouldComeInToContactWithAtWork,
        questionText: "Are your episodes of Fits / Blackouts / Fainting or unexplained loss of consciousness triggered by anything that you could come in to contact with at work?",
    },
    {
        id: questionIds.HowManyEpisodesOfFitsHaveYouExperiencedDuringTheLastYear,
        questionText: "How many episodes of faints / fits /  blackouts or loss of consciousness have you experienced during the last year?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToDiabetesInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to Diabetes in the last two years?",
    },
    {
        id: questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToDiabetesInTheLastTwoYears,
        questionText: "Have you ever had more than two consecutive weeks off sick due to Diabetes in the last two years?",
    },
    {
        id: questionIds.AreYourDiabetesSymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateYourDiabetes,
        questionText: "Do you require any adaptations in the workplace to accommodate your Diabetes?",
    },
    {
        id: questionIds.HaveYouHadAHypoGlycaemicEpisodeInTheLast12Months,
        questionText: "Have you had a hypo glycaemic episode in the last 12 months?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToStomachOrBowelProblemsInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to Stomach or Bowel problems in the last two years?",
    },
    {
        id: questionIds.HaveYouEverHadMoreThanTwoConsecutiveWeeksOffSickDueToStomachOrBowelProblems,
        questionText: "Have you ever had more than two consecutive weeks off sick due to Stomach or Bowel problems?",
    },
    {
        id: questionIds.AreYourStomachOrBowelSymptomsWellControlled,
        questionText: "Are your symptoms well controlled?",
    },
    {
        id: questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateAnyStomachOrBowelProblems,
        questionText: "Do you require any adaptations in the workplace to accommodate any Stomach or Bowel problems?",
    },
    {
        id: questionIds.HaveYouBeenAdmittedToHospitalDueToAnyOtherUnspecifiedHealthProblemInTheLastTwoYears,
        questionText: "Have you been admitted to hospital due to any other unspecified health problem / condition in the last two years?",
    },
    {
        id: questionIds.HaveYouHadMoreThanTwoConsecutiveWeeksOffSickDueToAnyOtherUnspecifiedHealthProblemInTheLastTwoYears,
        questionText: "Have you had more than two consecutive weeks off sick due to any other unspecified health problem / condition in the last two years?",
    },
    {
        id: questionIds.IfYouAreOnMedicationAreYourOtherHealthSymptomsWellControlled,
        questionText: "If you are on medication are your symptoms well controlled?",
    },
    {
        id: questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateDueToAnyOtherUnspecifiedHealthProblem,
        questionText: "Do you require any adaptations in the workplace to accommodate due to any other unspecified health problem / condition?",
    },
    {
        id: questionIds.DoYouHaveDyslexiaOrDyspraxia,
        questionText: "Do you have dyslexia or dyspraxia?",
    },
    {
        id: questionIds.DoYouHaveAnAutisticSpectrumOrOtherNeurodiverseCondition,
        questionText: "Do you have an autistic spectrum, ADHD, obsessive compulsive disorder (OCD) or other neurodiverse condition?",
    },
    {
        id: questionIds.DoYouRequireAnyAdaptationsInTheWorkplaceToAccommodateYourNeurodiverseCondition,
        questionText: "Do you require any adaptations in the workplace to accommodate your neurodiverse condition?",
    },
];
